module.exports = __webpack_public_path__ + "img/icon_evaluaciones_hover.82f0c844.svg";